<div class="pn-wrapper">

 
  <div class="pn-screen" *ngIf="isView('form')">
    <div class="pn-screen-head">
      <div class="pn-screen-title">Report a passing</div>
      <div class="pn-screen-sub">
        Please share what you know. Other beneficiaries will be notified and asked to confirm.
        No documents are required.
      </div>
    </div>

    <!-- Account holder (read-only, auto-selected) -->
    <div class="pn-field">
      <label class="pn-label">Account holder</label>
      <div class="pn-auto-field">
        <div class="pn-avatar pn-avatar--purple">{{ accountHolder.initials }}</div>
        <div>
          <div class="pn-auto-name">{{ accountHolder.fullName }}</div>
          <!-- <div class="pn-auto-hint">Auto-selected · read only</div> -->
        </div>
      </div>
    </div>

    <!-- Date of passing -->
    <div class="pn-field">
      <label class="pn-label">Date of passing</label>
      <input
        class="pn-input"
        type="date"
        [(ngModel)]="form.dateOfPassing"
        [max]="'2099-12-31'"
      />
    </div>

    <!-- Relationship -->
    <div class="pn-field">
      <label class="pn-label">Your relationship to the account holder</label>
      <select class="pn-input pn-select" [(ngModel)]="form.relationship">
        <option value="" disabled>Select relationship</option>
        <option *ngFor="let rel of relationshipOptions" [value]="rel">{{ rel }}</option>
      </select>
    </div>

    <!-- Notes -->
    <div class="pn-field">
      <label class="pn-label">
        Notes
        <span class="pn-label-optional">(optional)</span>
      </label>
      <textarea
        class="pn-input pn-textarea"
        rows="3"
        placeholder="Anything else the other beneficiaries should know..."
        [(ngModel)]="form.notes"
      ></textarea>
    </div>

    <!-- Info notice -->
    <div class="pn-banner pn-banner--info">
      <i class="ti ti-info-circle" aria-hidden="true"></i>
      <span>
        No documents required. You will not be asked to upload a death certificate.
        Submitting this will notify all other beneficiaries on this account immediately.
      </span>
    </div>

    <!-- Actions -->
    <div class="pn-actions">
      <button
        class="pn-btn pn-btn--primary"
        [disabled]="!canSubmitForm()"
        (click)="submitForm()"
      >
        <i class="ti ti-send" aria-hidden="true"></i>
        Submit
      </button>
      <button class="pn-btn pn-btn--outline" (click)="cancelForm()">
        Cancel
      </button>
    </div>
  </div>


  <div class="pn-screen" *ngIf="isView('pending')">

    <!-- Confirmation header -->
    <div class="pn-center-hero">
 <div class="pn-hero-icon pn-hero-icon--success">
  <i class="ti ti-send"></i>
</div>


  <div class="pn-hero-title">Notification submitted</div>

  <div class="pn-hero-sub">
    <p>We've notified all other beneficiaries on <strong>{{ accountHolder.fullName }}'s</strong>
    account. They have 72 hours to confirm or dispute.</p>
  </div>
</div>

    <!-- Live countdown -->
    <div class="pn-countdown">
      <div class="pn-countdown-label">Time remaining for peer confirmation</div>
      <div class="pn-countdown-time">{{ countdownDisplay() }}</div>
      <div class="pn-countdown-units">hrs &nbsp;&nbsp; min &nbsp;&nbsp; sec</div>
    </div>

    <!-- Status steps -->
    <div class="pn-section-label">Current status</div>

    <div class="pn-step-row">
     <div class="pn-step-dot pn-step-dot--done">
  <i class="ti ti-check"></i>
</div>
      <div>
        <div class="pn-step-title">Notification submitted</div>
        <div class="pn-step-sub">{{ notificationDetail.submittedAt }} · by you</div>
      </div>
    </div>

    <div class="pn-step-row">
     <div class="pn-step-dot pn-step-dot--active">
  <i class="ti ti-clock"></i>
</div>
      <div>
        <div class="pn-step-title pn-step-title--active">Waiting for peer confirmation</div>
        <div class="pn-step-sub">
          {{ secondaryBeneficiary.firstName }} notified via push notification and email
        </div>
      </div>
    </div>

    <div class="pn-step-row">
      <div class="pn-step-dot pn-step-dot--wait"></div>
      <div>
        <div class="pn-step-title pn-step-title--muted">Access decision</div>
        <div class="pn-step-sub">Pending outcome</div>
      </div>
    </div>

    <div class="pn-divider"></div>

    <div class="pn-info-row">
      <i class="ti ti-bell" aria-hidden="true"></i>
      <span>
        You'll be notified when the status changes. A reminder is sent to other beneficiary.
        <!-- {{ secondaryBeneficiary.firstName }} at 48 hours if no response is received. -->
      </span>
    </div>

    <!-- Dev helper: simulate outcomes -->
    <div class="pn-divider"></div>
    <div class="pn-section-label">Simulate outcome</div>
    <div class="pn-sim-row">
      <button class="pn-btn pn-btn--outline pn-btn--sm" (click)="goTo('access-unlocked')">
        Peer confirmed
      </button>
      <button class="pn-btn pn-btn--outline pn-btn--sm" (click)="goTo('attestation')">
        No response (72h)
      </button>
      <button class="pn-btn pn-btn--outline pn-btn--sm" (click)="goTo('access-frozen')">
        Dispute filed
      </button>
      <button class="pn-btn pn-btn--outline pn-btn--sm" (click)="goTo('peer-response')">
        View peer screen
      </button>
      <button class="pn-btn pn-btn--outline pn-btn--sm" (click)="goTo('reminder')">
        View 48h reminder
      </button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════
       PEER RESPONSE VIEW — secondary beneficiary screen
  ══════════════════════════════════════════════════════════ -->
  <div class="pn-screen" *ngIf="isView('peer-response')">

    <div class="pn-center-hero">
  <div class="pn-hero-icon pn-hero-icon--purple">
  <i class="ti ti-bell-ringing"></i>
</div>
      <div class="pn-hero-title">Confirmation request</div>
      <div class="pn-hero-sub">Your response is needed within the 72-hour window</div>
    </div>

    <!-- Notification detail card -->
    <div class="pn-card pn-mb14">
      <div class="pn-section-label pn-mb8">Notification details</div>
      <div class="pn-detail-grid">
        <div class="pn-detail-cell">
          <div class="pn-detail-label">Submitted by</div>
          <div class="pn-detail-value">{{ notificationDetail.submittedBy.fullName }}</div>
          <div class="pn-detail-hint">Beneficiary</div>
        </div>
        <div class="pn-detail-cell">
          <div class="pn-detail-label">Account holder</div>
          <div class="pn-detail-value">{{ notificationDetail.accountHolder.fullName }}</div>
        </div>
        <div class="pn-detail-cell">
          <div class="pn-detail-label">Date of passing</div>
          <div class="pn-detail-value">{{ notificationDetail.dateOfPassing }}</div>
        </div>
        <div class="pn-detail-cell">
          <div class="pn-detail-label">Relationship</div>
          <div class="pn-detail-value">{{ notificationDetail.relationship }}</div>
        </div>
      </div>
    </div>

    <!-- Countdown pill -->
    <div class="pn-pill-center pn-mb16">
      <div class="pn-countdown-pill">
        <i class="ti ti-clock" aria-hidden="true"></i>
        {{ peerCountdownLabel }}
      </div>
    </div>

    <div class="pn-question">
      Do you confirm that {{ accountHolder.fullName }} has passed away?
    </div>

    <!-- Actions -->
    <div class="pn-actions pn-actions--col">
      <button
        class="pn-btn pn-btn--primary pn-btn--full"
        (click)="confirmNotification()"
      >
        <i class="ti ti-check" aria-hidden="true"></i>
        Yes, I confirm this notification
      </button>
      <button
        class="pn-btn pn-btn--danger pn-btn--full"
        (click)="disputeNotification()"
      >
        <i class="ti ti-x" aria-hidden="true"></i>
        No, I dispute this notification
      </button>
    </div>

    <div class="pn-fine-print">
      Only dispute if you believe this notification is false. Disputing will immediately
      freeze access and notify the Continuum team.
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════
       48H REMINDER VIEW
  ══════════════════════════════════════════════════════════ -->
  <div class="pn-screen" *ngIf="isView('reminder')">

    <div class="pn-screen-head">
      <div class="pn-screen-title">Reminder notification</div>
      <div class="pn-screen-sub">
        Sent automatically at 48 hours if no response is received.
        Delivered via push notification and email simultaneously.
      </div>
    </div>

    <!-- Push notification preview -->
    <div class="pn-section-label pn-mb8">Push notification</div>
    <div class="pn-push-wrap pn-mb16">
      <div class="pn-push-card">
  <div class="pn-push-icon pn-push-icon--amber">
  <i class="ti ti-timer"></i>
</div>
        <div class="pn-push-content">
          <div class="pn-push-title">Reminder — response needed</div>
          <div class="pn-push-body">
            You have 24 hours left to confirm or dispute the passing notification for
            {{ accountHolder.fullName }}. Please respond before the deadline.
          </div>
          <div class="pn-push-time">48 hours after initial notification · Tap to respond</div>
        </div>
      </div>
    </div>

    <!-- Email preview -->
    <div class="pn-section-label pn-mb8">Email notification</div>
    <div class="pn-email-card">
      <div class="pn-email-header pn-email-header--amber">
        <div class="pn-email-logo pn-email-logo--amber">
  <i class="ti ti-clock"></i>
</div>
        <span class="pn-email-brand">Continuum — reminder</span>
      </div>
      <div class="pn-email-body">
        <div class="pn-email-badge pn-email-badge--amber">
          <i class="ti ti-clock" aria-hidden="true"></i>
          24 hours remaining
        </div>
        <div class="pn-email-subject">Reminder: your response is still needed</div>
        <div class="pn-email-text">
          Hi {{ secondaryBeneficiary.firstName }},<br><br>
          You have <strong>24 hours left</strong> to confirm or dispute the passing notification
          for <strong>{{ accountHolder.fullName }}</strong> submitted by
          <strong>{{ currentBeneficiary.firstName }}</strong>.<br><br>
          If no response is received by the deadline, the process will proceed automatically
          under an alternate path.
        </div>
        <div class="pn-email-deadline">
          Deadline: <strong>{{ notificationDetail.deadlineAt }}</strong>
        </div>
        <button class="pn-email-cta pn-email-cta--amber" (click)="goTo('peer-response')">
          Respond now →
        </button>
      </div>
      <div class="pn-email-footer">
        Automated reminder. You are a designated beneficiary on a Continuum account.
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════
       ACCESS UNLOCKED VIEW — Scenario A or Scenario B post-attest
  ══════════════════════════════════════════════════════════ -->
  <div class="pn-screen" *ngIf="isView('access-unlocked')">

    <div class="pn-success-hero">
      <div class="pn-hero-icon pn-hero-icon--green">
  <i class="ti ti-lock-open"></i>
</div>
      <div class="pn-hero-title pn-hero-title--green">Access unlocked</div>
      <div class="pn-hero-sub">
        {{ notificationDetail.confirmedBy?.firstName }} confirmed this notification.
        You now have full access to
        <strong>{{ accountHolder.fullName }}'s</strong> legacy account.
      </div>
    </div>

    <!-- Confirmed by banner -->
    <div class="pn-card pn-card--green pn-mb14">
      <div class="pn-confirmed-row">
        <i class="ti ti-circle-check pn-confirmed-icon" aria-hidden="true"></i>
        <div>
          <div class="pn-confirmed-title">
            Confirmed by {{ notificationDetail.confirmedBy?.fullName }}
          </div>
          <div class="pn-confirmed-sub">
            Today at 10:05 AM · 3 of 1 secondary beneficiaries responded
          </div>
        </div>
      </div>
    </div>

    <!-- What's now accessible -->
    <div class="pn-section-label">You now have access to</div>
    <div class="pn-access-list pn-mb20">
      <div
        class="pn-access-item"
        *ngFor="let section of accessibleSections; trackBy: trackByLabel"
      >
        <i [class]="'ti ' + section.icon + ' pn-access-icon'" aria-hidden="true"></i>
        <div>
          <div class="pn-access-label">{{ section.label }}</div>
          <div class="pn-access-sub">{{ section.sub }}</div>
       <div
    class="pn-access-sub pn-access-sub--success"
    *ngIf="section.sub2"
  >
    <i class="fas fa-check-circle"></i>
    {{ section.sub2 }}
  </div>
        </div>
      </div>
    </div>

    <!-- <button class="pn-btn pn-btn--primary">
      <i class="ti ti-arrow-right" aria-hidden="true"></i>
      Go to account
    </button> -->
  </div>

  <!-- ══════════════════════════════════════════════════════════
       ATTESTATION VIEW — Scenario B
  ══════════════════════════════════════════════════════════ -->
  <div class="pn-screen" *ngIf="isView('attestation')">

    <div class="pn-attest-header">
    <div class="pn-attest-icon">
  <i class="ti ti-pencil"></i>
</div>
      <div>
        <div class="pn-screen-title">One more step required</div>
        <div class="pn-attest-sub">Legal attestation before access is granted</div>
      </div>
    </div>

    <div class="pn-context-box pn-mb14">
      The 72-hour peer confirmation window has closed with no response received.
      To proceed, please complete the statement below.
    </div>

    <!-- Attestation box -->
    <div class="pn-attest-wrap">

      <!-- Instructional copy — client-specified verbatim -->
      <div class="pn-attest-instruction-title">Please read carefully before proceeding</div>
      <div class="pn-attest-instruction-body pn-mb14">
        Because no secondary beneficiary has confirmed this notification, we need you to
        complete the following step before access is granted.
      </div>

      <!-- Checkbox + legal statement — client-specified copy; names auto-populated -->
      <div
        class="pn-attest-check-row"
        [class.pn-attest-check-row--checked]="attestChecked()"
        (click)="toggleAttestation()"
        role="checkbox"
        [attr.aria-checked]="attestChecked()"
        tabindex="0"
        (keydown.space)="toggleAttestation()"
      >
        <div class="pn-checkbox" [class.pn-checkbox--on]="attestChecked()">
          <i class="ti ti-check" aria-hidden="true"></i>
        </div>
        <div class="pn-attest-stmt">
          I, <strong>{{ currentBeneficiary.fullName }}</strong>, confirm that
          <strong>{{ accountHolder.fullName }}</strong> passed away on
          <strong>{{ notificationDetail.dateOfPassing }}</strong>.
          I understand that by checking this box, I am making a legal statement.
          I acknowledge that submitting false information to gain unauthorized access
          to another person's private account may expose me to civil liability and
          criminal prosecution under applicable law.
        </div>
      </div>

      <!-- Log notice — client-specified verbatim -->
      <div class="pn-attest-log">
        <i class="ti ti-shield-lock" aria-hidden="true"></i>
        <span>
          This confirmation will be recorded with your name, IP address, and the
          date and time of submission.
        </span>
      </div>
    </div>

    <!-- Submit -->
    <button
      class="pn-btn pn-btn--primary pn-attest-submit"
      [disabled]="!canSubmitAttestation()"
      [class.pn-btn--disabled]="!canSubmitAttestation()"
      (click)="submitAttestation()"
    >
      <i class="ti ti-lock-open" aria-hidden="true"></i>
      Submit attestation &amp; unlock access
    </button>

    <div class="pn-fine-print pn-fine-print--center">
      By submitting, you agree this is a legally binding statement.
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════
       ACCESS FROZEN VIEW — Scenario C
  ══════════════════════════════════════════════════════════ -->
  <div class="pn-screen" *ngIf="isView('access-frozen')">

    <div class="pn-screen-head">
      <div class="pn-screen-title">Access frozen</div>
      <div class="pn-screen-sub">
        An active dispute has been filed. Access is frozen immediately for all parties.
        Both parties have been directed to resolve this through appropriate legal channels.
      </div>
    </div>

    <div class="pn-frozen-grid">

      <!-- Initiating beneficiary -->
      <div class="pn-frozen-col">
        <div class="pn-frozen-col-label">Initiating beneficiary</div>

        <div class="pn-frozen-hero">
 <div class="pn-frozen-icon">
  <i class="ti ti-lock"></i>
</div>
          <div class="pn-frozen-title">Access frozen</div>
          <div class="pn-frozen-sub">A dispute has been raised on this notification.</div>
        </div>

        <div class="pn-card pn-card--red pn-mb10">
          <div class="pn-frozen-disputed-by">
            Disputed by {{ notificationDetail.disputedBy?.fullName }}
          </div>
          <div class="pn-frozen-disputed-time">Today at 10:12 AM</div>
        </div>

        <div class="pn-frozen-desc pn-mb10">
          Access to this account is temporarily frozen. To resolve this, you will need
          to engage appropriate legal channels.
        </div>

        <div class="pn-card pn-card--surface">
          <div class="pn-section-label pn-mb8">Next steps</div>
          <ol class="pn-next-steps">
            <li>Consult an estate attorney or probate court</li>
            <li>Obtain documented legal resolution</li>
            <li>Provide resolution to Continuum</li>
            <li>Admin will restore access upon resolution</li>
          </ol>
        </div>
      </div>

      <!-- Disputing beneficiary -->
      <div class="pn-frozen-col">
        <div class="pn-frozen-col-label">Disputing beneficiary</div>

        <div class="pn-frozen-hero pn-frozen-hero--amber">
   <div class="pn-frozen-icon pn-frozen-icon--amber">
  <i class="ti ti-alert-triangle"></i>
</div>
          <div class="pn-frozen-title pn-frozen-title--amber">Dispute submitted</div>
          <div class="pn-frozen-sub">Account access is frozen pending resolution.</div>
        </div>

        <div class="pn-frozen-desc pn-mb10">
          Your dispute has been recorded. The Continuum team has been notified.
          Access remains frozen until a legal resolution is provided by both parties.
        </div>

        <div class="pn-card pn-card--surface">
          <div class="pn-section-label pn-mb8">Next steps</div>
          <ol class="pn-next-steps">
            <li>Consult an estate attorney or probate court</li>
            <li>Work toward a documented resolution</li>
            <li>Both parties must agree on resolution terms</li>
            <li>Continuum will restore access upon resolution</li>
          </ol>
        </div>
      </div>
    </div>

    <!-- Admin notification banner -->
    <div class="pn-banner pn-banner--danger pn-mt14">
      <i class="ti ti-info-circle" aria-hidden="true"></i>
      <span>
        Continuum does not adjudicate disputes. Access remains frozen until documented
        legal resolution is provided. The Continuum admin has been notified and will
        manually restore access once resolution is confirmed.
      </span>
    </div>
  </div>

</div>
